import styled from 'styled-components';

export const MobileDropdownMenuSectionLinkAnchorRow = styled.div`
    display: flex;
    align-items: center;
    /* 0 because it conflicts with the dropdown trigger button */
    padding-right: 0px;
    min-height: 53px;
    box-sizing: border-box;
`;
